export default defineNuxtPlugin(async () => {
  if (!import.meta.client) return

  try {
    const { PushNotifications } = await import('@capacitor/push-notifications')
    await PushNotifications.checkPermissions()
  } catch {
    return
  }

  const auth = useAuthStore()
  if (auth.accessToken) {
    const push = usePushNotifications()
    await push.restoreToken()
    if (!push.deviceToken.value) {
      await push.register()
    }
  }
})
